import { vuexfireMutations, firestoreAction } from "vuexfire";
import { inspectionsCollection, db } from "@/plugins/db.js";
export default {
  namespaced: true,

  // setup the reactive todos property
  state: {
    inspections: [],
    inspectionProfile: {},
    measurements: []
  },

  mutations: {
    ...vuexfireMutations
  },
  actions: {
    bindInspections: firestoreAction(context => {
      return context.bindFirestoreRef("inspections", inspectionsCollection);
    }),

    bindAnInspection: firestoreAction((context, id) => {
      return context.bindFirestoreRef(
        "inspectionProfile",
        inspectionsCollection.doc(id)
      );
    }),
    bindInspectionsOfEquipment: firestoreAction((context, id) => {
      return context.bindFirestoreRef(
        "inspections",
        inspectionsCollection
          .where("equipmentProfile", "==", db.doc(`equipments/${id}`))
          .orderBy("dateCreated")
          .where("disabled", "==", false)
      );
    })
  },
  getters: {}
};
